import theme from "@shared/utils/themeColors";
import { usePostStore } from "../../store/postStore";
import type { Post } from "../../types/post.types";

interface PostActionsProps {
  post: Post;
  onShare?: () => void;
}

export function PostActions({ post, onShare }: PostActionsProps) {
  const { likePost, unlikePost } = usePostStore();

  const handleLikeClick = async () => {
    try {
      if (post.isLiked) {
        await unlikePost(post.id!);
      } else {
        await likePost(post.id!);
      }
    } catch (error) {
      console.error("Error interacting with post:", error);
      // TODO: Show error to user
    }
  };

  return (
    <div className="mt-4">
      <div className="flex space-x-3">
        {/* Like Button */}
        <button
          onClick={handleLikeClick}
          className={`flex items-center text-sm font-medium ${
            post.isLiked
              ? theme.text.link
              : `text-gray-600 dark:text-gray-300 ${theme.text.brandHover}`
          }`}
        >
          <svg
            className={`mr-1.5 h-4 w-4 ${
              post.isLiked ? theme.bg.fill : "fill-current"
            }`}
            viewBox="0 0 16 16"
          >
            <path d="M14.682 2.318A4.485 4.485 0 0 0 11.5 1 4.377 4.377 0 0 0 8 2.707 4.383 4.383 0 0 0 4.5 1a4.5 4.5 0 0 0-3.182 7.682L8 15l6.682-6.318a4.5 4.5 0 0 0 0-6.364Zm-1.4 4.933L8 12.247l-5.285-5A2.5 2.5 0 0 1 4.5 3c1.437 0 2.312.681 3.5 2.625C9.187 3.681 10.062 3 11.5 3a2.5 2.5 0 0 1 1.785 4.251h-.003Z" />
          </svg>
          <span>{post.likes}</span>
        </button>

        {/* Share Button */}
        <button
          onClick={onShare}
          className={`flex items-center text-sm font-medium ${
            post.isShared
              ? theme.text.link
              : `text-gray-600 dark:text-gray-300 ${theme.text.brandHover}`
          }`}
        >
          <svg
            className={`mr-1.5 h-4 w-4 ${
              post.isShared ? theme.bg.fill : "fill-current dark:fill-current"
            }`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path d="M13 7h2v6a1 1 0 0 1-1 1H4v2l-4-3 4-3v2h9V7ZM3 9H1V3a1 1 0 0 1 1-1h10V0l4 3-4 3V4H3v5Z" />
          </svg>
          <span>{post.shares}</span>
        </button>

        {/* Comment Button */}
        <button
          className={`flex items-center text-sm font-medium ${
            post.isCommented
              ? theme.text.link
              : `text-gray-600 dark:text-gray-300 ${theme.text.brandHover}`
          }`}
        >
          <svg
            className={`mr-1.5 h-4 w-4 ${
              post.isCommented
                ? theme.bg.fill
                : "fill-current dark:fill-current"
            }`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.1 0 7s3.6 7 8 7h.6l5.4 2v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7zm4 10.8v2.3L8.9 12H8c-3.3 0-6-2.2-6-5s2.7-5 6-5 6 2.2 6 5c0 2.2-2 3.8-2 3.8z" />
          </svg>
          <span>{post.comments}</span>
        </button>
      </div>
    </div>
  );
}
